<router-outlet
  coreDynamicStyle
  coreSessionMonitor
  coreSessionStorage></router-outlet>
